import AttachmentItem from "./AttachmentItem"

export default function KnowledgeList({ attachments, refresh }) {
    return (
        <div className="space-y-3">
            <h2 className="text-lg font-semibold mb-4">รายการเนื้อหา</h2>

            {attachments.map((item) => (
                <AttachmentItem
                    key={item.id}
                    item={item}
                    refresh={refresh}
                />
            ))}
        </div>
    )
}
